<template>
  <div id="login-view">
    <b-overlay>
      <section class="">
        <div class="d-flex justify-content-center">
          <img
            src="@/assets/site/images/loader.gif"
            v-if="loader === true"
            class="img-fluid loader-width"
            alt
          />
        </div>
        <div class="container" v-if="loader === false">
          <img
            class=""
            src="@/assets/site/images/chair.png"
            style="width: 25%; position: absolute; right: 70%; "
            alt=""
          />
          <img
            class="swing"
            src="@/assets/site/images/chair_2.png"
            style="width: 30%; position: absolute; left: 65%"
            alt=""
          />
          <div class="card" style="border: none !important">
            <h1 class="card-title">
              <img
                src="@/assets/site/images/grey.png"
                class="img-fluid"
                alt=""
              />
            </h1>
            <small class="card-subtitle"
              >Enter your credentials and get access</small
            >
            <form @submit.prevent="submitForm" class="card-form">
              <label for="username">Email</label>
              <div class="card-input-container username">
                <input
                  type="text"
                  placeholder="Enter your email address"
                  v-model.trim="email"
                  id="username"
                  @keydown.space.prevent
                  @input="validateEmail('email')"
                />
                <span class="text-danger" v-if="errors.email">{{
                  this.errors.email[0]
                }}</span>
              </div>
              <label for="password">Password</label>
              <div class="card-input-container password">
                <input
                  :type="passwordVisible ? 'text' : 'password'"
                  placeholder="Enter your password"
                  v-model.trim="password"
                  id="password"
                  @input="validatePassword('password')"
                  style="width:90%;margin-right:5px;"
                />
                 <span class="password-toggle" @click="togglePasswordVisibility">
                  <i class="fas" :class="passwordVisible ?  'fa-eye':'fa-eye-slash'"></i>
                </span>
                
                <span class="text-danger" v-if="errors.password">{{
                  this.errors.password[0]
                }}</span>
               
              </div>
              <div class="row">
                <div class="col-8">
                  <span class="text-danger">{{ error_msg }}</span>
                </div>
              </div>
              <button @click="login" class="card-button">Sign In</button>

              <small class="card-forgot-password"
                ><router-link to="/site/forgot"
                  >Forgot your password?</router-link
                ></small
              >
            </form>
          </div>
        </div>
      </section>
    </b-overlay>
  </div>
</template>

<script>
export default {
  name: "LoginView",
  data() {
    return {
      email: null,
      password: null,
      errors: [],
      error_msg: null,
      loader: false,
      passwordVisible: false
    };
  },
  methods: {
    validateEmail(field) {
      let validationStatus = false;
      const emailRegex = /^\S+@\S+\.\S+$/;
      if (!this[field]?.trim()) {
        this.$set(this.errors, field, ["Email is required."]);
      } else if (!emailRegex.test(this[field])) {
        this.$set(this.errors, field, ["Invalid email format."]);
      } else {
        validationStatus = true;
        this.$set(this.errors, field, null);
      }
      return validationStatus;
    },

    validatePassword(field) {
      let validationStatus = false;
      const minLength = 8;
      const hasUpperCase = /[A-Z]/.test(this[field]);
      const hasLowerCase = /[a-z]/.test(this[field]);
      const hasNumber = /\d/.test(this[field]);
      if (!this[field]?.trim()) {
        this.$set(this.errors, field, ["Password is required."]);
      } else if (
        this[field]?.length < minLength ||
        !hasUpperCase ||
        !hasLowerCase ||
        !hasNumber
      ) {
        this.$set(this.errors, field, [
          "Password must be at least 8 characters and include at least one uppercase letter, one lowercase letter, and one number.",
        ]);
      } else {
        validationStatus = true;
        this.$set(this.errors, field, null);
      }
      return validationStatus;
    },

    login() {
      const emailValid = this.validateEmail("email");
      const passwordValid = this.validatePassword("password");
      if (emailValid && passwordValid) {
        this.errors = [];
        this.error_msg = null;
        this.loader = true;
        let apiUrl = process.env.VUE_APP_URL + "api/login";
        let method_type = "post";
        fetch(apiUrl, {
          method: method_type,
          headers: {
            "content-type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            email: this.email,
            password: this.password,
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.status === true) {
              var userData = {
                user: data.user,
                role: data.user.role,
                token: data.token,
                status: true,
              };
              localStorage.setItem("userData", JSON.stringify(userData));
              if (userData.user.role == "Admin") {
                window.location.href = "admin";
              } else {
                window.location.href = "admin";
              }
            } else if (data.status === false) {
              localStorage.clear();
              this.loader = false;
              this.error_msg = data.message;
            } else {
              this.loader = false;
              this.errors = data.errors;
            }
          })
          .catch(function(err) {
            console.log("User Data", "Error : " + err.message, "error");
          });
      }
    },
    
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    }
  }
};
</script>
